<template>
	<admin-base-layout>
		<template slot="admin-page-header">
			<div class="flex-wrap-spacing">
				<h3 class="page-header">Health &amp; Monitoring</h3>
			</div>
			<div class="flex-wrap-spacing health-actions">
				<button class="btn btn-primary tests_add_namespace_action" @click="getStats()">
					<i class="fa fa-sync-alt fa-fw"></i></button>
			</div>
		</template>

		<template slot="admin-page-content">
			<loader v-if="!stats"></loader>

			<div v-if="stats">
				<div class="row">
					<div class="col-xs-12 pad0">
						<div class="table-responsive">
							<table class="table table-hover tests_users_table table-50-50">
								<thead>
									<tr>
										<th>Metric</th>
										<th>Value</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>DB latency</td>
										<td>{{stats.db_lat}} milliseconds</td>
									</tr>
									<tr>
										<td>In Memory Cache latency</td>
										<td>{{stats.memcache_lat}} milliseconds</td>
									</tr>
									<tr>
										<td>Internet Access</td>
										<td>{{stats.internet_access}}</td>
									</tr>
									<tr>
										<td>Processing elapsed</td>
										<td>{{stats.lambda_elapsed}} milliseconds</td>
									</tr>
									<tr>
										<td>Total HTTP elapsed</td>
										<td>{{stats.http_elapsed}} milliseconds</td>
									</tr>
									<tr>
										<td>Inferred HTTP latency</td>
										<td>{{stats.http_elapsed - stats.lambda_elapsed}} milliseconds</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-xs-12 pad0">
						<div class="table-responsive">
							<table class="table table-hover table_envs tests_users_table table-50-50">
								<thead>
									<tr>
										<th>Env Name</th>
										<th>Value</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(v,k) in stats.process_env" v-bind:key="k">
										<td class='env_key_cell'>{{k}}</td>
										<td>{{v}}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</template>
	</admin-base-layout>
</template>

<script>
const logger = require("@/utils/logger");
const usersService = require("@/utils/users-api");
import router from "@/router";
import Vue from "vue";
const utils = require("@/utils/utils");

export default {
  data() {
    return {
      stats: null
    };
  },
  methods: {
    getStats() {
      this.stats = null;
      usersService
        .stats()
        .then(stats => {
          this.stats = stats;
        })
        .catch(utils.axiosErrorHandler);
    }
  },
  mounted() {
    this.getStats();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loader {
  margin-top: 10px;
  text-align: center;
}
.table-item-actions {
  text-align: right;
}

.health-actions {
  text-align: right;
  flex: 1;
}
.flex-wrap-spacing {
  margin-bottom: 10px;
}

.table-item-actions a {
  margin-left: 10px;
}
.table-item-actions a:hover {
  color: #000;
}

td {
  word-break: break-all;
}
.table-50-50 td:first-child {
  width: 50%;
}
.lambda-error {
  color: red;
  font-weight: bold;
}
td:first-child {
  font-weight: bold;
}
</style>
 


// WEBPACK FOOTER //
// src/components/superadmin/Health.vue